import styled from 'styled-components'
import { columnAndRowsWidth } from '..'
import { BqTooltip } from '@beeq/react'

export const RowsWrapper = styled.div`
  flex: 1 1 auto;
  overflow-y: auto;
  overflow-x: hidden;
  @media screen and (max-width: 800px) {
    width: 350px;
  }
`

export const RowWrapper = styled.div`
  display: flex;
  align-items: center;
`

export const RoleCell = styled.span`
  width: ${(props) => props.$width + 'px'};
  display: flex;
  align-items: center;
  gap: 8px;
  flex-grow: 1;
  padding: var(--bq-spacing-s);
  height: 52px;
  font-weight: var(--bq-font-weight--medium);
`

export const StyledCell = styled.span`
  width: ${(props) => props.$width + 'px'};
  // moves the row's last cell due to scrollbar width, to keep rows and columns aligned
  margin-right: ${(props) =>
    props.$hasTableVerticalScrollbar && props.$width === columnAndRowsWidth.actions ? '-14px' : ''};
  display: flex;
  align-items: center;
  justify-content: center;
`
export const StyledTooltip = styled(BqTooltip)`
  --bq-tooltip--max-width: 480px;
  font-weight: var(--bq-font-weight--regular);
`
